import { isVideoFile } from './isVideoFile';
import { validateDentalPhotoFileSize } from './validateDentalPhotoFileSize';
import { validateDentalVideoFileSize } from './validateDentalVideoFileSize';

export const validateDentalMediaFileSize = (file: File) => {
  if (isVideoFile(file)) {
    return validateDentalVideoFileSize(file);
  }

  return validateDentalPhotoFileSize(file);
};
